import React, { useCallback } from 'react';
import { useActiveService } from 'hooks/useActiveService';
import PropTypes from 'prop-types';
import { Hidden } from '@mui/material';
import Menu from '@mui/icons-material/Menu';
import MoreVert from '@mui/icons-material/MoreVert';
import ViewList from '@mui/icons-material/ViewList';
import { IconButton } from '@totalsoft/rocket-ui';
import HeaderLinks from './HeaderLinks';
import { withAreaSetter } from 'providers/AreasConsumers';
import { areas } from '../../constants/areas';
import { AppBar, Toolbar, MinimizeSidebar, HeaderResponsive } from './HeaderStyle';
import FlexBox from 'components/common/FlexBox';

function Header({ drawerMinimized, handleDrawerMinimizeToggle, handleDrawerOpenToggle, setElemByAreaKey }) {
  const { activeServiceLoaded } = useActiveService();
  const headerRef = useCallback(
    elem => {
      if (elem) setElemByAreaKey(areas.header, elem);
    },
    [setElemByAreaKey]
  );

  return (
    activeServiceLoaded && (
      <AppBar id='header-area' position='sticky'>
        <Toolbar>
          <Hidden mdDown>
            <MinimizeSidebar>
              {drawerMinimized ? (
                <IconButton color='primary' variant='text' fontSize='medium' onClick={handleDrawerMinimizeToggle}>
                  <ViewList fontSize='small' />
                </IconButton>
              ) : (
                <IconButton color='primary' variant='text' fontSize='medium' onClick={handleDrawerMinimizeToggle}>
                  <MoreVert fontSize='small' />
                </IconButton>
              )}
            </MinimizeSidebar>
          </Hidden>
          <FlexBox xs={{ direction: 'column', alignItems: 'start' }} gap={1} grow={1} py={1} alignItems='center' ref={headerRef}></FlexBox>
          <HeaderLinks />
          <Hidden mdUp>
            <HeaderResponsive>
              <IconButton color='primary' variant='text' aria-label='open drawer' onClick={handleDrawerOpenToggle}>
                <Menu fontSize='small' />
              </IconButton>
            </HeaderResponsive>
          </Hidden>
        </Toolbar>
      </AppBar>
    )
  );
}

Header.propTypes = {
  drawerMinimized: PropTypes.bool.isRequired,
  handleDrawerMinimizeToggle: PropTypes.func.isRequired,
  handleDrawerOpenToggle: PropTypes.func.isRequired,
  setElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaSetter(Header);
